<script lang="ts" setup>
import { Popup, Search } from "vant";
import { nextTick, onMounted, ref } from "vue";
import api from "@/modules/api";
import { ThreadListInstance } from "../../ThreadList.vue";

const props = defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  (e: "update:show", isShow: boolean): void;
  (e: "confirm", item: PresetMatePrompt): void;
}>();

const searchRef = ref<HTMLTextAreaElement | null>(null);
const isSearch = ref<boolean>(false);
const keyword = ref<string>("");

const activeItem = ref<PresetMatePrompt>();

const PER_PAGE = 18;
const listRef = ref<ThreadListInstance>();
const list = ref<PresetMatePrompt[]>([]);
const fetchPresetMate = async () => {
  let page = list.value.length / PER_PAGE + 1;
  if (!Number.isInteger(page)) return false;
  const data = await api.readPresetMatePromptPage({
    keyword: keyword.value,
    pagination: {
      page,
      perPage: PER_PAGE,
    },
  });
  list.value = [...list.value, ...data.page.data];
  return data.page.data.length === PER_PAGE;
};

onMounted(() => {
  nextTick(() => {
    searchRef.value?.focus();
  });
});

// 发送消息
const handleSearch = async () => {
  isSearch.value = true;
  activeItem.value = undefined;
  list.value = [];
  listRef.value?.resetScrollLoadingState();
};

const clickConfirm = () => {
  emit("update:show", false);
  emit("confirm", activeItem.value!);
};
</script>
<template>
  <popup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="bottom"
    round
    class="flex flex-col w-full h-[100%]"
    :close-on-popstate="true"
  >
    <div class="px-2">
      <div class="flex items-center mt-5 gap-1">
        <button class="btn btn-xs btn-ghost" @click="$router.back">
          <i class="iconfont icon-left"></i>
        </button>
        <div class="text-xl font-semibold flex-1">
          {{ $t(`trait.mode.preset`) }}
        </div>
        <button
          class="btn btn-sm btn-primary"
          :disabled="!activeItem"
          @click="clickConfirm"
        >
          {{ $t(`Buttons.confirm`) }}
        </button>
      </div>
      <div class="w-full block rounded overflow-hidden my-2.5">
        <Search
          ref="searchRef"
          v-model="keyword"
          @search="handleSearch"
          @clear="isSearch = false"
          :placeholder="$t('Message.searchMateEnter')"
          class="p-0 pr-1"
        />
      </div>
    </div>
    <div class="flex-1 overflow-hidden relative">
      <div class="h-full overflow-hidden pb-10">
        <ThreadList
          ref="listRef"
          class="px-4"
          :on-scroll-load="fetchPresetMate"
        >
          <div class="grid grid-cols-3 gap-2">
            <div
              class="text-center"
              v-for="item in list"
              :class="[
                activeItem?.id === item.id ? 'text-primary' : 'text-my-gray',
              ]"
              @click="activeItem = item"
            >
              <div
                :class="[
                  'border-2 relative',
                  activeItem?.id === item.id
                    ? ' border-primary'
                    : ' border-transparent',
                ]"
              >
                <BaseImg :url="item.avatarUrl" ratio="1:1" />
                <div
                  v-if="activeItem?.id === item.id"
                  class="absolute bottom-2 right-2 bg-white w-[16px] h-[16px] flex justify-center items-center rounded-full"
                >
                  <i class="iconfont icon-select text-xl"></i>
                </div>
              </div>

              <p class="text-base font-semibold line-clamp-1">
                {{ item.name }}
              </p>
              <p class="mt-1 line-clamp-1">{{ item.work }}</p>
            </div>
          </div>
        </ThreadList>
      </div>
    </div>
  </popup>
</template>
